import { Store } from 'utils';

class ActiveInfoStore extends Store {

	getInitialState() {
		return {
			info: null
		}
	}

	onActiveInfoChanged(state, data) {
		state.info = data.info;
	}

	getActiveUserCount() {
		var info = this.getState().info;

		if(info == null) {
			return 0;
		} else {
			return info.onlineUsers;
		}
	}
}

const store = new ActiveInfoStore();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/activeinfostore.js